module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerMediumItalic.ea604a4b.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerMediumItalic.otf
// module id = 1070
// module chunks = 0